import { useAttributesContext } from "shared/contexts/AttributesContext";
import { ContextProviderName } from "shared/contexts/types";
import { GENERIC_FILTER } from "shared/filterDefinitions";
import { DataType } from "shared/types";

import { SchemaEntryOverride, UseSchema } from "./types";
import { getGroupBySelectOptions } from "./utils/group-by-utils";
import {
  getAttributeMap,
  getDisplayLabelFunction,
  getFilterFunction,
  getSchemaEntryFunction,
  getSchemaForAccessorFunction,
  getSchemaFromAttributes,
} from "./utils/schema-utils";

const VALUES_ENDPOINT = "v2/assets";

const useAssetsSchema = (accessorsToHide: string[] = []): UseSchema => {
  const { groupByValues, attributes } = useAttributesContext(
    ContextProviderName.Asset
  );

  const attributeMap = getAttributeMap(attributes);

  const getDisplayLabel = getDisplayLabelFunction(attributeMap);

  const getFilter = getFilterFunction(
    GENERIC_FILTER,
    attributeMap,
    VALUES_ENDPOINT
  );

  const getSchemaEntry = getSchemaEntryFunction(getFilter, attributeMap);

  const overrides: SchemaEntryOverride = {
    modelYear: {
      schemaOverride: {
        dataType: DataType.STRING,
      },
    },
  };

  const schema = getSchemaFromAttributes(
    attributes,
    getSchemaEntry,
    overrides,
    undefined,
    accessorsToHide
  );

  const getSchemaForAccessor = getSchemaForAccessorFunction(schema);

  const attributesForGroupBy = attributes?.filter(
    ({ ID }) => !accessorsToHide.includes(ID)
  );

  const groupBySelectOptions = getGroupBySelectOptions(
    attributesForGroupBy,
    undefined,
    groupByValues
  );

  return {
    schema,
    getDisplayLabel,
    attributeMap,
    attributes,
    groupBySelectOptions,
    attributeAccessors: schema.map(
      ({ accessor, filter }) => filter?.fieldName || accessor
    ),
    getSchemaForAccessor,
    getSchemaEntry,
  };
};

export default useAssetsSchema;
